import React from "react";
import InstantMoveIcon from "../../assets/images/move-in.png";
import SecurityDespositeIcon from "../../assets/images/security-desposite.png";
import NoBrokerageIcon from "../../assets/images/no-brokerage.png";
import MaintainanceIcon from "../../assets/images/maintainance.png";
import Card from "../common/card";
import ownBuilding from "../../assets/images/own-building.jpg";
import { Link } from "react-router-dom";
import usability from "../../assets/images/usability.png";
import noTouch from "../../assets/images/no-touch.png";
import INR from "../../assets/images/inr.png";

export const HowItWork = ({
  className = "",
  isBuildingSectionRequired = true,
  isCardSectionRequired = true,
}) => {
  const HowItWorkBenefits = [
    {
      iconPath: "/icons/move-in.png",
      title: "Instant Move-In",
      description:
        "Say goodbye to lengthy waits. Find, finalize, and move into your dream home without any delay.",
    },
    {
      iconPath: "/icons/security-desposite.png",
      title: "Lowest Security Deposit",
      description:
        "Ease rental stress by paying a minimal security deposit. Understanding financial challenges.",
    },
    {
      iconPath: "/icons/no-brokerage.png",
      title: "No Brokerage",
      description:
        "Enjoy no-brokerage renting with shared spaces, curated events, and a vibrant community lifestyle.",
    },
    {
      iconPath: "/icons/maintainance.png",
      title: "Prompt Maintenance",
      description:
        "We conduct regular property inspections and provide on-demand services to keep your space.",
    },
    {
      iconPath: "/icons/usability.png",
      title: "App-Based Process",
      description:
        "User-friendly mobile app to assist you from finding a house till you vacate—from browsing, booking to paying rents and managing maintenance.",
    },
    {
      iconPath: "/icons/inr.png",
      title: "Transparent Pricing",
      description:
        "Know exactly what you’re paying for with clear, upfront pricing and no hidden charges.",
    },
    {
      iconPath: "/icons/no-touch.png",
      title: "No Landlord Pressure",
      description:
        "Enjoy complete freedom and privacy with zero interference or pressure from landlords.",
    },
  ];
  return (
    <>
      {isCardSectionRequired && (
        <section className={`howit-work ${className}`}>
          <div className="container">
            <div className="benefits__row">
              {HowItWorkBenefits.map((cardItem, index) => (
                <div
                  className="benefits__col"
                  data-aos="fade-up"
                  data-aos-duration={600}
                  key={`benefit-card-${index}`}
                >
                  <Card cardItem={cardItem} />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
      {isBuildingSectionRequired && (
        <section className={`own-building ${className}`}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-md-6">
                <div className="section-heading align-items-start mb-0">
                  <h2>Own a building/flat/villa ?</h2>
                  <div className="sec-line">
                    <span className="sec-line1" />
                    <span className="sec-line2" />
                  </div>
                  <h3>Let us manage it</h3>
                  <p>
                    List your property in a few easy steps and enjoy hassle-free
                    management services, including on-time rent and proactive
                    maintenance.
                  </p>
                  <Link to="/contact-us" className="btn btn-primary">
                    Explore our Property Management
                  </Link>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="image">
                  <img src={ownBuilding} alt="building" />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};
